module.exports = __webpack_public_path__ + "img/currency.15544c36.svg";